import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { useSetAtom } from 'jotai';
import { useReducerAtom } from 'jotai/utils';
import React, { type FC } from 'react';
import VendorAnalytics from '../../../../../decorators/vendorAnalytics';
import {
	fetchReviewsAtom,
	searchSortFilterAtom,
	searchSortFilterReducer,
} from '../atoms';
import { BaseAppliedPill } from './base-applied-pill';

const PhotoPill: FC = () => {
	const [, dispatch] = useReducerAtom(
		searchSortFilterAtom,
		searchSortFilterReducer,
	);
	const fetchReviews = useSetAtom(fetchReviewsAtom);
	const { track } = useAnalyticsContext();
	const vendor = useAppSelector((state) => state.vendor.vendor);

	const handleClose = () => {
		const vendorAnalytics = vendor
			? new VendorAnalytics(vendor).baseEventProps()
			: {};

		dispatch({ type: 'toggle-photos', payload: undefined });
		fetchReviews();

		track({
			event: 'Review Interaction',
			properties: {
				...vendorAnalytics,
				action: 'remove photo filter',
			},
		});
	};

	return (
		<BaseAppliedPill
			label="Reviews with photos"
			onClose={handleClose}
			ariaLabel="Remove photo filter"
		/>
	);
};

export { PhotoPill };
